import { render, staticRenderFns } from "./PageSettingsPageDescription.vue?vue&type=template&id=cd83a5b2&scoped=true"
import script from "./PageSettingsPageDescription.vue?vue&type=script&lang=js"
export * from "./PageSettingsPageDescription.vue?vue&type=script&lang=js"
import style0 from "./PageSettingsPageDescription.vue?vue&type=style&index=0&id=cd83a5b2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd83a5b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd83a5b2')) {
      api.createRecord('cd83a5b2', component.options)
    } else {
      api.reload('cd83a5b2', component.options)
    }
    module.hot.accept("./PageSettingsPageDescription.vue?vue&type=template&id=cd83a5b2&scoped=true", function () {
      api.rerender('cd83a5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/page/PageSettingsPageDescription.vue"
export default component.exports